import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function FeaturedSection() {
  const featuredComics = comics.filter((c) => c.featured);

  return (
    <section id="featured" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            精选韩漫推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心挑选的高质量韩漫，每一部都值得细细品读
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}